import { api } from './client';

/** Panel de Consumos (ADMIN). Prefijo: /api/usage */

export interface ConsumoBucket {
  turnosApi: number;
  usosCli: number;
  usd: number;
  inputTokens: number;
  outputTokens: number;
}

export type RangoConsumo = 'hoy' | 'semana' | 'quincena' | 'mes' | 'siempre' | 'rango';

export interface TotalPeriodo {
  usd: number;
  turnosApi: number;
  usosCli: number;
}

export interface UsageSummary {
  range: RangoConsumo;
  desde: string;
  /** Fin del rango de fechas (exclusivo); null: hasta ahora. */
  hasta: string | null;
  /** Las cifras de arriba a la vez (no dependen del rango elegido). */
  totales: { hoy: TotalPeriodo; semana: TotalPeriodo; quincena: TotalPeriodo; mes: TotalPeriodo; siempre: TotalPeriodo & { desde: string | null } };
  total: ConsumoBucket & { modelosSinPrecio: string[] };
  porAgente: Array<ConsumoBucket & { agentId: string | null; nombre: string }>;
  porCanal: Array<ConsumoBucket & { channelId: string | null; nombre: string }>;
  porTipo: Array<ConsumoBucket & { kind: string }>;
  tendencia: Array<{ dia: string; usd: number; turnosApi: number; usosCli: number }>;
}

export interface ModelPrice {
  inUsdPorMTok: number;
  outUsdPorMTok: number;
  cacheWriteUsdPorMTok: number;
  cacheReadUsdPorMTok: number;
}

/**
 * Medidor del cliente (F1): conversaciones del mes contra el cupo. ADMIN —
 * sin USD. Informativo: pasarse nunca corta el servicio.
 */
export interface UsageMeter {
  mes: string;
  conversaciones: number;
  cupo: number;
  pct: number;
  excedido: boolean;
}

export const getMeter = () => api.get<UsageMeter>('/api/usage/meter');

/** `dias`: el rango de fechas (AAAA-MM-DD) cuando `range` es 'rango'. */
export const getSummary = (range: RangoConsumo, dias: { desde?: string; hasta?: string } = {}) =>
  api.get<UsageSummary>(
    `/api/usage/summary?${new URLSearchParams({ range, ...(range === 'rango' ? Object.fromEntries(Object.entries(dias).filter(([, v]) => v)) : {}) })}`,
  );

export const getPrices = () =>
  api.get<{ precios: Record<string, ModelPrice>; defaults: Record<string, ModelPrice> }>(
    '/api/usage/prices',
  );

export const putPrices = (precios: Record<string, ModelPrice>) =>
  api.put<{ precios: Record<string, ModelPrice> }>('/api/usage/prices', precios);

export const getCliWindow = () =>
  api.get<{ configurado: boolean; reporte: unknown }>('/api/usage/cli-window');
